var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"instructions-image px-3 pb-1 border"},[_c(_setup.ImageRetina,{staticClass:"w-100",attrs:{"filename":_setup.image,"fluid-grow":"","sharp":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }